import Form from "../../common/Form";
import { loginFormFields } from "../../config/formFields/Login";
import { iLoginData, iLoginRequest } from "../../helpers/interfaces/auth";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { authStorageKey, getAuth, login } from "../../services/AuthService";
import { Col, Row } from "react-bootstrap";
import './auth.css';
import Link from "../../common/Link";

const initialValues: iLoginRequest = {
    email: '',
    password: '',
};

export default function LoginPage() {
  const defaultRedirect = '/';
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState<string|null>(null);
  const params = new URLSearchParams(window.location.search)
  const alertCode: string | null = params.get('alert');
  const redirect: string | null = params.get('redirect');
  let loggedRedirect = redirect ? redirect : defaultRedirect;

  if (loggedRedirect.startsWith('/logout')) {
    loggedRedirect = defaultRedirect;
  }

  async function loginSubmit(values: iLoginRequest): Promise<void> {
    await login(values).then((authData: iLoginData) => {
      if (authData) {
        navigate(loggedRedirect);

        localStorage.setItem(authStorageKey, JSON.stringify(authData));
      } else {
        throw new Error('Login error');
      }
    }).catch((e: any) => {
      setLoginError('Accesso fallito, per favore verifica i dati inseriti e riprova, grazie!')
    })
  }

  useEffect(() => {
    if (getAuth() !== null) {
      navigate(loggedRedirect);
    }
  }, [navigate, loggedRedirect]);

  return (
    <>
      {alertCode === "1" && <div className="alert alert-warning" role="alert">
        Devi effettuare l'accesso con il tuo account per poter visualizzare questa pagina {/*: {loggedRedirect} */}
      </div>}
      {loginError && <div className="alert alert-danger" role="alert">{loginError}</div>}
      <h1>Accedi</h1>
      <div id="login">
        <Row>
          <Col lg="6">
            <Form
              id="login-form"
              className="auth-form"
              formFields={loginFormFields()}
              onSubmit={loginSubmit}
              initialValues={initialValues}
              submitText={"Accedi"}
            />
          </Col>
          <Col lg="6" className="text-center">
            {/* <h4>Oppure accedi con il tuo profilo social</h4> */}
          </Col>
        </Row>
        <div className="text-center my-4">
          <div id="login-signup-text">
            Non hai un account?
          </div>
          <h4>
            <Link href="/registrazione">REGISTRATI</Link>
          </h4>
        </div>
      </div>
    </>
  );
}
